import { render, staticRenderFns } from "./PhotoHelp.vue?vue&type=template&id=3912e624&scoped=true&"
import script from "./PhotoHelp.vue?vue&type=script&lang=js&"
export * from "./PhotoHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3912e624",
  null
  
)

export default component.exports